import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

// Services
export const fetchServices = () => apiClient.get("/services").then((r) => r.data);
export const fetchService = (slug) => apiClient.get(`/services/${slug}`).then((r) => r.data);

// Tech topics
export const fetchTechTopics = () => apiClient.get("/tech-topics").then((r) => r.data);
export const fetchTechTopic = (slug) => apiClient.get(`/tech-topics/${slug}`).then((r) => r.data);

// Articles
export const fetchArticles = (params = {}) =>
  apiClient.get("/articles", { params }).then((r) => r.data);
export const fetchArticle = (slug) => apiClient.get(`/articles/${slug}`).then((r) => r.data);

// Case studies
export const fetchCaseStudies = () => apiClient.get("/case-studies").then((r) => r.data);

// Talent
export const fetchTalent = () => apiClient.get("/talent").then((r) => r.data);

// Contact
export const submitContact = (payload) =>
  apiClient.post("/contact", payload).then((r) => r.data);

// Payments
export const fetchPlans = () => apiClient.get("/payments/plans").then((r) => r.data);

export const createCheckoutSession = (payload) =>
  apiClient.post("/payments/checkout/session", payload).then((r) => r.data);

export const fetchCheckoutStatus = (sessionId) =>
  apiClient.get(`/payments/checkout/status/${sessionId}`).then((r) => r.data);

export const submitEnterpriseLead = (payload) =>
  apiClient.post("/payments/enterprise-lead", payload).then((r) => r.data);

// Assessment leads
export const submitAssessmentLead = (payload) =>
  apiClient.post("/assessment-lead", payload).then((r) => r.data);
